const { stats } = require('@fiverr-private/obs');
const { LOGS_KEY } = require('../../constants');
const { logger } = require('../../../shared/logger');
const { buildTrackingPath } = require('./buildTrackingUrl');
const { BASE_PATH, EVENT_TYPES } = require('./constants');

class TrackingService {
    constructor() {
        this.trackTiming = this.trackTiming.bind(this);
        this.trackCount = this.trackCount.bind(this);
        this.isInitialized = this.isInitialized.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    initialize(data = {}) {
        const requiredParams = ['funnelName', 'pageName'];
        const isValid = requiredParams.reduce((acc, curr) => acc && !!data[curr], true);

        if (!isValid) {
            logger.warn('Required params are missing for TrackingService initialization', {
                required_params: requiredParams.join(','),
                given_params: JSON.stringify(data),
            });
            this.data = null;
        } else {
            this.data = data;
        }
    }

    isInitialized() {
        return !!this.data;
    }

    /**
     * Tracks a timing event to grafana
     * @param { int } startTime - The time that the tracked event started at (no need to do end-start calc)
     * @param { string } requestName - The name of the tracked request
     * @param { string } extraPath - Extra path keys could be added splitted by '.'
     */
    trackTiming(startTime, requestName, extraPath) {
        if (!this.isInitialized()) {
            logger.warn("TrackingService wasn't properly initialized before usage", {
                requestName,
                [LOGS_KEY]: 'Error in trackTiming',
            });

            return;
        }

        if (!startTime || !Number.isInteger(startTime)) {
            logger.warn('startTime is required as an integer represents the initial time (use Date.now())', {
                requestName,
                [LOGS_KEY]: 'Error in trackTiming',
            });

            return;
        }

        try {
            const eventPath = buildTrackingPath(
                this.data.funnelName,
                this.data.pageName,
                requestName,
                EVENT_TYPES.RESPONSE_TIME,
                extraPath
            );

            const duration = Date.now() - startTime;

            eventPath && stats.time(BASE_PATH, eventPath, duration);
        } catch (error) {
            logger.warn(error, {
                funnelName: this.data.funnelName,
                pageName: this.data.pageName,
                requestName,
                eventType: EVENT_TYPES.RESPONSE_TIME,
                [LOGS_KEY]: 'Error in buildTrackingPath',
            });
        }
    }

    /**
     * Tracks a count event to grafana
     * @param { string } requestName - The name of the tracked request
     * @param { string } eventType - The type of the tracked event (EVENT_TYPES constant should be used)
     * @param { string } extraPath - Extra path keys could be added split by '.'
     */
    trackCount(requestName, eventType, extraPath) {
        if (!this.isInitialized()) {
            logger.warn("TrackingService wasn't properly initialized before usage", {
                requestName,
                eventType,
                [LOGS_KEY]: 'Error in trackCount',
            });

            return;
        }

        const eventPath = buildTrackingPath(
            this.data.funnelName,
            this.data.pageName,
            requestName,
            eventType,
            extraPath
        );

        eventPath && stats.count(BASE_PATH, eventPath);
    }
}

const tracker = new TrackingService();

module.exports = {
    EVENT_TYPES,
    default: tracker,
    tracker,
};
